import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logout } from "@/assets/icons/Icons";
import { cn } from "@/lib/utils";
import { ConfirmDialog } from "@/components/dialogs/confirm";
import { useModalVoid } from "@/hooks/useModal";
import { useCallback } from "react";
import { useAuth } from "@/hooks/useAuth";

export function Nav(props: { readonly children: React.ReactNode }) {
	return (
		<nav className="bg-sidebar-background text-sidebar-primary flex-1 flex flex-col">
			{props.children}
		</nav>
	);
}
export function NavGroup(props: { readonly children: React.ReactNode }) {
	return <div className="grid auto-rows-fr">{props.children}</div>;
}
export function NavTitle(props: { readonly children: React.ReactNode }) {
	return (
		<div className="h-10 mb-2 pl-(--sidebar-icons-width) uppercase mt-3">
			{props.children}
		</div>
	);
}

interface NavItemProps {
	readonly title: string;
	readonly description?: string;
	readonly url: string;
	readonly icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
	// children?: NavSubItemProps[];
}
export function NavItem(props: NavItemProps) {
	const linkClass = cn(
		"flex decoration-none ",
		"transition-colors duration-100 ease-in-out",
		"hover:bg-sidebar-background-hover active:bg-sidebar-background-hover focus:bg-sidebar-background-hover aria-selected:bg-sidebar-background-hover",
	);
	const path = useLocation();

	return (
		<Link
			to={props.url}
			aria-selected={path.pathname === props.url}
			className={linkClass}
			style={{ WebkitTapHighlightColor: "transparent" }}
		>
			<div className="text-sidebar-accent w-(--sidebar-icons-width) px-5 pt-2">
				<props.icon />
			</div>
			<div className="w-(--sidebar-text-width) border-b-1 border-sidebar-primary pt-2 pb-2 pr-2">
				<h2 className="text-sidebar-accent font-medium">{props.title}</h2>
				<p className="leading-[125%] mt-1 ">{props.description}</p>
			</div>
		</Link>
	);
}

export function CerrarSesion() {
	const navigate = useNavigate();
	const { logout } = useAuth();
	const linkClass = cn(
		"flex decoration-none py-5",
		"hover:bg-sidebar-background-hover active:bg-sidebar-background-hover focus:bg-sidebar-background-hover",
		"hover:text-sidebar-accent",
	);

	const dialog = useModalVoid();
	const { close: closeDialog } = dialog;
	const cerrarSesion = useCallback(() => {
		closeDialog();
		logout();
		void navigate("/login");
	}, [closeDialog, logout, navigate]);

	return (
		<>
			<button
				onClick={dialog.open}
				className={linkClass}
				style={{ WebkitTapHighlightColor: "transparent" }}
			>
				<div className="text-sidebar-accent w-(--sidebar-icons-width) px-5">
					<Logout />
				</div>
				<div className="w-(--sidebar-text-width) border-sidebar-primary">
					<h2 className="text-sidebar-accent">Cerrar sesión</h2>
				</div>
			</button>

			<ConfirmDialog
				shown={dialog.shown}
				title="Cerrar sesión"
				message="¿Estás seguro de que quieres cerrar sesión?"
				onConfirm={cerrarSesion}
				close={dialog.close}
			/>
		</>
	);
}

// eslint-disable-next-line react-refresh/only-export-components -- This is a component? This rule kinda sucks
export const Spacer = styled.div`
	flex: 1;
`;
